<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <div class="logo">Private Banking</div>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>New Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" 
                 placeholder="Enter new password">
          <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility('password')" 
                  [attr.aria-label]="'Toggle password visibility'">
            <mat-icon>{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          @if (resetPasswordForm.get('password')?.hasError('required')) {
            <mat-error>
              Password is required
            </mat-error>
          }
          @if (resetPasswordForm.get('password')?.hasError('minlength')) {
            <mat-error>
              Password must be at least 8 characters
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Confirm Password</mat-label>
          <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" 
                 placeholder="Confirm new password">
          <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility('confirmPassword')" 
                  [attr.aria-label]="'Toggle password visibility'">
            <mat-icon>{{hideConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          @if (resetPasswordForm.get('confirmPassword')?.hasError('required')) {
            <mat-error>
              Confirm password is required
            </mat-error>
          }
          @if (resetPasswordForm.get('confirmPassword')?.hasError('mismatch')) {
            <mat-error>
              Passwords do not match
            </mat-error>
          }
        </mat-form-field> 
        @if (error) {
          <div class="error-message">
            {{ error }}
          </div>
        }
        <button mat-raised-button color="primary" type="submit" class="submit-button" [disabled]="resetPasswordForm.invalid || loading">
          @if (loading) {
            <mat-spinner diameter="20" class="spinner"></mat-spinner>
          } @else {
            <span>Reset Password</span>
          }
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>